// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"307":"57362dfa","478":"642bd848"}[chunkId] + ".chunk.css";
};